import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Panel, DropdownButton, NavItem } from "react-bootstrap";
import { IoPencil, IoTrash, IoEllipsisVertical } from "react-icons/io5";

import { orderBy } from "lodash";
import matchSorter from "match-sorter";

import { formatDate } from "../../../helpers/date";

const ContractNoteList = ({
  contract,
  search,
  isMobile,
  onClickEdit,
  onClickDelete
}) => {
  let contractNotesView = (
    <div
      className="content-wrapper vertical-center -full"
      style={{ margin: 0 }}
    >
      <h4>No notes available</h4>
    </div>
  );

  if (contract) {
    let { notes } = contract;

    if (search) {
      notes = matchSorter(contract.notes, search, {
        keys: ["note", "created_on"]
      });
    }

    if (notes && notes.length) {
      contractNotesView = (
        <Row>
          {orderBy(notes, "modified_on", "desc").map((note) => {
            const timestamp = formatDate(
              note.created_on,
              !isMobile ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
            );

            return (
              <Panel bsStyle="info" key={note.id} className="note-panel">
                <Panel.Heading>
                  <Row>
                    <Col md={6} xs={6}>
                      <h5>{note.title}</h5>
                    </Col>
                    <Col md={6} xs={6}>
                      <p>
                        <span style={{ marginRight: "10px" }}>
                          {note.created_by.split("@")[0]}
                        </span>
                        •<em style={{ marginLeft: "10px" }}>{timestamp}</em>
                      </p>
                    </Col>
                  </Row>
                </Panel.Heading>
                <Panel.Body>
                  <Col md={11} xs={10}>
                    <blockquote>
                      <div dangerouslySetInnerHTML={{ __html: note.note }} />
                    </blockquote>
                  </Col>
                  <Col md={1} xs={2}>
                    <div className="actions pull-right">
                      <DropdownButton
                        title={
                          <span>
                            <IoEllipsisVertical />
                          </span>
                        }
                        id="dropdown"
                      >
                        <NavItem onClick={() => onClickEdit(note.id)}>
                          <IoPencil />
                          View
                        </NavItem>
                        <NavItem onClick={() => onClickDelete(note.id)}>
                          <IoTrash />
                          Delete
                        </NavItem>
                      </DropdownButton>
                    </div>
                  </Col>
                </Panel.Body>
              </Panel>
            );
          })}
        </Row>
      );
    }
  }

  return <div>{contractNotesView}</div>;
};

ContractNoteList.propTypes = {
  contract: PropTypes.object.isRequired,
  search: PropTypes.string,
  isMobile: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func
};

export default ContractNoteList;
